module.exports = __webpack_public_path__ + "static/media/logo_company_nav_1.7e10aefa.png";